import { get, isEmpty } from 'lodash';

import {
  MARK_PERSISTOR_FOR_PURGE,
  DISPATCH_USER_CONSENT,
  FETCH_MASTER_DATA,
  FETCH_AVAILABLE_CITIES,
  FIND_GUEST_LOCATION,
  FETCH_VIEW_CART,
  FETCH_ORDERED_ITEMS,
  ATTEMPT_LOGIN_SUCCESS,
  BEGIN_AJAX_CALL,
  END_AJAX_CALL,
  DISPATCH_SIGNIN_DATA,
  DISPATCH_AUTH_TOKEN,
  API_ERROR_RESPONSE,
  DISPATCH_PARENT_ROUTE,
  DISPATCH_CONTEXTUAL_HOME,
  DISPATCH_GUEST_DATA,
  CLEAR_GUEST_DATA,
  GUEST_FEEDBACK,
  GET_BRAND_FEEDBACK_SETUP,
  CLEAR_GUEST_FEEDBACK,
  GET_ORDER_FEEDBACK_SETUP,
  FETCH_ORDER_FEEDBACK,
  GET_ORDER_FEEDBACK_RESPONSE,
  CLEAR_FETCH_ORDER_FEEDBACK,
  FETCH_USER_DETAILS,
  FETCH_USER_ADDRESSES,
} from './actionType';
import {
  fetchMasterDataApi,
  initiatePaymentApi,
  validatePaymentApi,
  verifyPaymentApi,
  updateProfileApi,
  getUserProfileDataApi,
  findGuestLocationApi,
  findGeoLocationApi,
  validateLocalitiesApi,
  createGuestFeedbackApi,
  updateGuestFeedbackApi,
  getBrandFeedbackSetupApi,
  fetchOrderFeedbackSetupApi,
  createOrderFeedbackApi,
  fetchOrderFeedbackByIdApi,
  fetchUserDetailsApi,
  updateUserDetailsApi,
  deleteUserAccountApi,
} from '../api/api';
import { isNativeWebView } from '../utils/helpers';
import { apiResponseCodes, storageTypes } from '../constants/globals';
import { setItem } from '../utils/storage';
import { DISPATCH_SELECTED_ADDRESS } from '../actions/actionType';

export const markPersistorForPurgeAction = (persistorMarkedForPurge) => async (dispatch) => {
  dispatch({
    type: MARK_PERSISTOR_FOR_PURGE,
    persistorMarkedForPurge,
  });
};

export const dispatchUserConsentAction = (userConsent) => async (dispatch) => {
  dispatch({
    type: DISPATCH_USER_CONSENT,
    userConsent,
  });
};

export const fetchMasterDataAction =
  ({ appName }) =>
  async (dispatch) => {
    dispatch({
      type: BEGIN_AJAX_CALL,
      showSpinner: true,
    });
    fetchMasterDataApi({ appName })
      .then((response) => {
        dispatch({
          type: FETCH_MASTER_DATA,
          masterData: get(response, 'data', {}),
        });
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() =>
        dispatch({
          type: END_AJAX_CALL,
          showSpinner: false,
        }),
      );
  };

export const clearViewCartItems = () => async (dispatch) => {
  dispatch({
    type: FETCH_VIEW_CART,
    items: {},
  });
};

export const updateProfileAction = (updateProfileReqBody, guestId) => async (dispatch) => {
  try {
    dispatch({
      type: BEGIN_AJAX_CALL,
      showSpinner: true,
    });
    const updateProfileData = await updateProfileApi({
      updateProfileReqBody,
      guestId,
    })
      .then((response) => {
        localStorage.setItem('GuestLoginData', JSON.stringify(get(response, 'data', {})));
        dispatch({
          type: ATTEMPT_LOGIN_SUCCESS,
          loginData: get(response, 'data', {}),
        });
        dispatch(dispatchGuestDataAction(get(response, 'data', {})));
        return response;
      })
      .catch((errorResponse) => {
        return get(errorResponse, 'response.data', {});
      });
    return updateProfileData;
  } catch (err) {
  } finally {
    dispatch({
      type: END_AJAX_CALL,
      showSpinner: false,
    });
  }
};

export const getUserProfileDataAction = (guestId) => async (dispatch) => {
  let userProfileData = {};
  try {
    dispatch({
      type: BEGIN_AJAX_CALL,
      showSpinner: true,
    });
    userProfileData = await getUserProfileDataApi({ guestId });
    localStorage.setItem('GuestLoginData', JSON.stringify(get(userProfileData, 'data', {})));
    dispatch({
      type: ATTEMPT_LOGIN_SUCCESS,
      loginData: get(userProfileData, 'data', {}),
    });
  } catch (err) {
  } finally {
    dispatch({
      type: END_AJAX_CALL,
      showSpinner: false,
    });
  }
};

export const dispatchGuestLoginDataAction = (guestLoginData) => async (dispatch) => {
  localStorage.setItem('GuestLoginData', JSON.stringify(get(guestLoginData, 'guest', {})));
  localStorage.setItem('AuthData', JSON.stringify(get(guestLoginData, 'auth', {})));
  dispatch({
    type: ATTEMPT_LOGIN_SUCCESS,
    loginData: get(guestLoginData, 'guest', {}),
  });
  dispatch({
    type: DISPATCH_AUTH_TOKEN,
    authData: get(guestLoginData, 'auth', {}),
  });
};

export const dispatchGuestDataAction = (guestData) => async (dispatch) => {
  dispatch({
    type: DISPATCH_GUEST_DATA,
    guestData,
  });
};

export const clearGuestDataAction = () => async (dispatch) => {
  dispatch({
    type: CLEAR_GUEST_DATA,
  });
};

export const initiatePaymentAction =
  ({ initiatePaymentReqBody, defaultGateway }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: BEGIN_AJAX_CALL,
        showSpinner: true,
      });

      const initiatePaymentresponse = await initiatePaymentApi({
        initiatePaymentReqBody,
        defaultGateway,
      })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return initiatePaymentresponse;
    } catch (err) {
      console.log(err);
    } finally {
      dispatch({
        type: END_AJAX_CALL,
        showSpinner: false,
      });
    }
  };

export const validatePaymentAction = (paymentresponse, defaultGateway) => async (dispatch) => {
  try {
    dispatch({
      type: BEGIN_AJAX_CALL,
      showSpinner: true,
    });

    const validatePaymentResponse = await validatePaymentApi({
      paymentresponse,
      defaultGateway,
    })
      .then((response) => {
        const validatePaymentResponseData = get(response, 'data', {});
        const orderedItems = get(validatePaymentResponseData, 'guestOrderDto', {});

        !isEmpty(orderedItems) &&
          dispatch({
            type: FETCH_ORDERED_ITEMS,
            orderedItems,
          });

        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });

    return validatePaymentResponse;
  } catch (err) {
    console.log(err);
  } finally {
    dispatch({
      type: END_AJAX_CALL,
      showSpinner: false,
    });
  }
};

export const verifyPaymentAction =
  ({ id }) =>
  async (dispatch) => {
    try {
      // dispatch({
      //   type: BEGIN_AJAX_CALL,
      //   showSpinner: true,
      // });
      let orderedItems = {};
      let verifyPaymentResponse = await verifyPaymentApi({
        id,
      })
        .then((response) => {
          verifyPaymentResponse = get(response, 'data', {});
          orderedItems = get(verifyPaymentResponse, 'guestOrderDto', {});
          dispatch({
            type: FETCH_ORDERED_ITEMS,
            orderedItems,
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return verifyPaymentResponse;
    } catch (err) {
      console.log(err);
    } finally {
      // dispatch({
      //   type: END_AJAX_CALL,
      //   showSpinner: false,
      // });
    }
  };

export const beginAjaxCallAction = () => async (dispatch) => {
  dispatch({
    type: BEGIN_AJAX_CALL,
    showSpinner: true,
  });
};

export const endAjaxCallAction = () => async (dispatch) => {
  dispatch({
    type: END_AJAX_CALL,
    showSpinner: false,
  });
};

export const dispatchSignInDataAction = (signIn) => async (dispatch) => {
  dispatch({
    type: DISPATCH_SIGNIN_DATA,
    signIn,
  });
};

export const dispatchParentRouteAction = (parentRoute) => async (dispatch) => {
  dispatch({
    type: DISPATCH_PARENT_ROUTE,
    parentRoute,
  });
};

export const apiErrorResponseAction = (errorResponse) => async (dispatch) => {
  dispatch({
    type: API_ERROR_RESPONSE,
    errorResponse,
  });
  dispatch({
    type: END_AJAX_CALL,
    showSpinner: false,
  });
};

export const clearApiErrorResponseAction = () => async (dispatch) => {
  dispatch({
    type: API_ERROR_RESPONSE,
    errorResponse: {},
  });
};

export const findGuestLocationAction =
  ({ guestId }) =>
  async (dispatch) => {
    try {
      const locationResponse = await findGuestLocationApi({ guestId })
        .then((response) => {
          let guestLocation = get(response, 'data', {});
          guestLocation = { ...guestLocation, timeStamp: Date.now() };
          setItem(storageTypes.localStorage, 'guestLocation', guestLocation); // eslint-disable-line
          dispatch({
            type: FIND_GUEST_LOCATION,
            guestLocation,
          });

          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });

      return locationResponse;
    } catch (error) {
      console.log(error);
    }
  };

export const dispatchGuestLocationAction = (cityName) => async (dispatch) => {
  dispatch({
    type: FIND_GUEST_LOCATION,
    guestLocation: { cityName },
  });
};

export const findGeoLocationAction = () => async (dispatch) => {
  let guestLocation = {};
  findGeoLocationApi()
    .then((response) => {
      guestLocation = get(response, 'location', {});
      setItem(storageTypes.localStorage, 'geoLocation', guestLocation);
      dispatch(findGuestLocationAction());
    })
    .catch((error) => {
      console.log(error);
    });
};

export const dispatchSelectedAddressAction = (selectedAddress) => async (dispatch) => {
  dispatch({
    type: DISPATCH_SELECTED_ADDRESS,
    selectedAddress,
  });
};

// Action to set contextual home state into the redux store
export const dispatchContextualHome = (contextualHome) => (dispatch) => {
  dispatch({
    type: DISPATCH_CONTEXTUAL_HOME,
    contextualHome,
  });
};

export const validateLocalitiesAction = (validateLocalitiesReqBody) => async (dispatch) => {
  try {
    const validateLocalitiesResponse = await validateLocalitiesApi(validateLocalitiesReqBody)
      .then((response) => response)
      .catch((errorResponse) => get(errorResponse, 'response', {}));

    return validateLocalitiesResponse;
  } catch (err) {
    console.error(err);
  }
};

export const createGuestFeedbackAction = (requestBody) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const createGuestFeedbackResponse = await createGuestFeedbackApi(requestBody)
      .then((response) => {
        const guestFeedback = get(response, 'data', {});
        dispatch({
          type: GUEST_FEEDBACK,
          guestFeedback,
        });
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });
    return createGuestFeedbackResponse;
  } catch (err) {
    console.error(err);
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const createOrderFeedbackAction = (requestBody) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const createOrderFeedbackResponse = await createOrderFeedbackApi(requestBody)
      .then((response) => {
        const orderFeedbackResponse = get(response, 'data', {});
        dispatch({
          type: GET_ORDER_FEEDBACK_RESPONSE,
          orderFeedbackResponse,
        });
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });
    return createOrderFeedbackResponse;
  } catch (err) {
    console.error(err);
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const updateGuestFeedbackAction = (requestBody) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const updateGuestFeedbackResponse = await updateGuestFeedbackApi(requestBody)
      .then((response) => {
        const updatedGuestFeedback = get(response, 'data', {});
        dispatch({
          type: GUEST_FEEDBACK,
          guestFeedback: updatedGuestFeedback,
        });
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });
    return updateGuestFeedbackResponse;
  } catch (err) {
    console.error(err);
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const fetchOrderFeedbackSetupAction = (requestBody) => async (dispatch) => {
  try {
    const brandFeedbackSetupResponse = await fetchOrderFeedbackSetupApi(requestBody)
      .then((response) => {
        const feedbackSetup = get(response, 'data', {});
        dispatch({
          type: GET_ORDER_FEEDBACK_SETUP,
          feedbackSetup,
        });
        return response;
      })
      .catch((errorResponse) => {
        return get(errorResponse, 'response', {});
      });
    return brandFeedbackSetupResponse;
  } catch (err) {
    console.error(err);
  } finally {
  }
};

export const fetchfeedbackByIdAction = (requestBody) => async (dispatch) => {
  try {
    const orderFeedbackResponse = await fetchOrderFeedbackByIdApi(requestBody)
      .then((response) => {
        const feedbackObj = get(response, 'data', {});
        dispatch({
          type: FETCH_ORDER_FEEDBACK,
          feedbackObj,
        });
        return response;
      })
      .catch((errorResponse) => {
        return get(errorResponse, 'response', {});
      });
    return orderFeedbackResponse;
  } catch (err) {
    console.error(err);
  } finally {
  }
};

export const clearFetchfeedbackByIdAction = () => async (dispatch) => {
  dispatch({
    type: CLEAR_FETCH_ORDER_FEEDBACK,
  });
};

export const getBrandFeedbackSetupAction = (requestBody) => async (dispatch) => {
  try {
    const brandFeedbackSetupResponse = await getBrandFeedbackSetupApi(requestBody)
      .then((response) => {
        const feedbackSetup = get(response, 'data', {});
        dispatch({
          type: GET_BRAND_FEEDBACK_SETUP,
          feedbackSetup,
        });
        return response;
      })
      .catch((errorResponse) => {
        return get(errorResponse, 'response', {});
      });
    return brandFeedbackSetupResponse;
  } catch (err) {
    console.error(err);
  } finally {
  }
};

export const clearGuestFeedbackAction = () => async (dispatch) => {
  dispatch({
    type: CLEAR_GUEST_FEEDBACK,
  });
};

export const fetchUserDetailsAction =
  ({ userId, accessToken }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const fetchUserDetailsResponse = await fetchUserDetailsApi({ userId, accessToken })
        .then((response) => {
          const userDetails = get(response, 'data', {});
          setItem(storageTypes.localStorage, 'GuestLoginData', userDetails);
          if (isNativeWebView) {
            const data = {
              eventType: { type: 'userDetails', data: userDetails },
            };
            window.ReactNativeWebView.postMessage(JSON.stringify(data));
          }
          dispatch({
            type: FETCH_USER_DETAILS,
            userDetails,
          });
          return response;
        })
        .catch((errorResponse) => {
          return get(errorResponse, 'response', {});
        });
      return fetchUserDetailsResponse;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const updateUserDetailsAction =
  (updateUserDetailsReqBody, accessToken) => async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const updateUserDetailsResponse = await updateUserDetailsApi(
        updateUserDetailsReqBody,
        accessToken,
      )
        .then((response) => {
          const userDetails = get(response, 'data', {});
          setItem(storageTypes.localStorage, 'GuestLoginData', userDetails);
          dispatch({
            type: FETCH_USER_DETAILS,
            userDetails,
          });
          return response;
        })
        .catch((errorResponse) => {
          return get(errorResponse, 'response', {});
        });
      return updateUserDetailsResponse;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const deleteUserAccountAction = () => async (dispatch) => {
  try {
    const deleteUserAccountResponse = await deleteUserAccountApi()
      .then((response) => {
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });
    return deleteUserAccountResponse;
  } catch (error) {
    console.error(error);
  }
};
